import { __awaiter } from "tslib";
import consoleEvents from '../consoleEvents';
import request from '../request';
import { ACCESS_TOKEN_REGEX_LIST, MIN_ACCESS_TOKEN_EXPIRE_IN_MINUTES } from './constants';
/**
 * @param  {boolean} tokenExpired - Boolean if token has expired, defaults to false.
 * @returns AxiosPromise
 */
export const fetchAccessToken = (tokenExpired = false) => request.post('/login/getTokens', {
    params: { tokenExpired },
    use: {
        apiVersion: false,
    },
});
/**
 * No params
 * @returns Jwt object - { accessToken: string, expiresOnDate: number }
 */
export const getJwt = () => {
    const jwtItem = localStorage.getItem('jwt');
    return jwtItem ? JSON.parse(jwtItem) : null;
};
/**
 * @param Jwt object - { accessToken: string, expiresOnDate: number }
 * @returns void
 */
export const setJwt = ({ accessToken, expiresOnDate }) => {
    localStorage.setItem('jwt', JSON.stringify({ accessToken, expiresOnDate }));
};
/**
 * @returns void
 */
export const removeJwt = () => localStorage.removeItem('jwt');
/**
 * @param  {number} expiresOnDate
 * @returns boolean
 */
export const isAccessTokenExpired = (expiresOnDate) => {
    const expireDate = new Date(expiresOnDate);
    return (new Date(expireDate.setMinutes(expireDate.getMinutes() - MIN_ACCESS_TOKEN_EXPIRE_IN_MINUTES)).toISOString() < new Date().toISOString());
};
/**
 * If url doesnt doesnt match any of the regex, return false
 *
 * @param  {string|undefined} url
 * @returns boolean
 */
export const isAccessTokenRequired = (url) => 
// @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
Object.values(ACCESS_TOKEN_REGEX_LIST).some((regex) => regex.test(url));
/**
 * @returns Promise
 */
export const fetchJwt = () => __awaiter(void 0, void 0, void 0, function* () {
    // Catch if error to not let error interceptor catch it. Do not use this method in refresh token interceptor
    try {
        const { data: jwt } = yield fetchAccessToken();
        return jwt;
    }
    catch (e) {
        consoleEvents.error(`Failed to fetch accessToken: ${e.message}`);
        return null;
    }
});
//# sourceMappingURL=accessToken.js.map